(function(){
    'use strict';
    angular.module('app').controller('ComplianceController', ComplianceController);

    ComplianceController.$inject = ['$scope', 'ComplianceTable'];

    function ComplianceController($scope, ComplianceTable) {
        const vm = this;

        init();
        function init() {
            getComplianceItems();
        }

        function getComplianceItems() {
            vm.complianceTable = new ComplianceTable().tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/ComplianceController.js